'use strict';

angular.module('atex.dam').factory('DamConfigurationService',
['$q', '$rootScope', '$timeout', 'ApplicationConfigurationService', 'AuthenticationService', 'DamInformerModal', 'DamTemplateService',
  'DamFieldMappingService', 'DamService', 'DamMarkAsService', 'DownloadService', 'ContentService', 'DamGalleryConfiguration', 'DamNotificationService','DamPartitionsService', 'configuration', 'preloader',
function($q, $rootScope, $timeout, ApplicationConfigurationService, AuthenticationService, DamInformerModal, DamTemplateService,
  DamFieldMappingService, DamService, DamMarkAsService, DownloadService, ContentService, DamGalleryConfiguration, DamNotificationService,DamPartitionsService, configuration, preloader) {
  var _isLoading = false;

  // Cfg to lookup fields from solr
  var lookups = {};
  var terms = [];
  var type = {};
  type.term = "objectType";
  type.name = "types";
  var publication = {};
  publication.term = "publication";
  publication.name = "publications";
  var edition = {};
  edition.term = "edition";
  edition.name = "editions";
  var zone = {};
  zone.term = "zone";
  zone.name = "zones";
  var section = {};
  section.term = "section";
  section.name = "sections";
  var partition = {};
  partition.term = "partition";
  partition.name = "partitions";
  var source = {};
  source.term = "source";
  source.name = "sources";
  terms.push(type);
  terms.push(publication);
  terms.push(edition);
  terms.push(zone);
  terms.push(section);
  terms.push(partition);
  terms.push(source);

  var imageMetadataConfigFile = "/onecms/polopoly_fs/atex.onecms.Widget-pExifMetadata!/config.json";

  var cropFormats = [];

  var loadDeferred = $q.defer();

  var createObjFromSource = function(source) {
    return {
     id: source,
     label: source
    };
  };

  var createObjFromPartition = function(id) {
    var partitions = DamPartitionsService.getAllPartitions();

    var partition = (partitions) ? (partitions[id]) ? partitions[id] : undefined : undefined;
    if (partition) {
      return {
        id: partition.id,
        icon: partition.icon,
        label: partition.label
      };
    }
  };

  var createObjFromObjType = function(typeId) {
    if (typeId==="article") {
      return {
        id: 'article',
        icon: 'pencil',
        label: '__ARTICLE_LABEL__'
      };
    } else if (typeId==="image") {
      return {
        id: 'image',
        icon: 'camera',
        label: '__IMAGE_LABEL__'
      };
    } else if (typeId==="page") {
      return {
        id: 'page',
        icon: 'file',
        label: '__PAGE_LABEL__'
      };
    } else if (typeId==="video") {
      return {
        id: 'video',
        icon: 'video-camera',
        label: '__VIDEO_LABEL__'
      };
    } else if (typeId==="audio") {
      return {
        id: 'audio',
        icon: 'volume-up',
        label: '__AUDIO_LABEL__'
      };
    }  else if (typeId==="graphic") {
      return {
        id: 'graphic',
        icon: 'bar-chart',
        label: '__GRAPHIC_LABEL__'
      };
    } else if (typeId==="collection") {
      return {
        id: 'collection',
        icon: 'folder',
        label: '__COLLECTION_LABEL__'
      };
    } else if (typeId==="tweet") {
      return {
        id: 'tweet',
        icon: 'twitter',
        label: '__tweet_LABEL__'
      };
    } else if (typeId==="instagram") {
      return {
        id: 'instagram',
        icon: 'instagram',
        label: '__instagram_LABEL__'
      };
    } else if (typeId==="job") {
      return {
        id: 'job',
        icon: 'tasks',
        label: '__JOB_LABEL__'
      };
    } else if (typeId==="embed") {
      return {
        id: 'embed',
        icon: 'file-code-o',
        label: '__EMBED_LABEL__'
      };
    } else if (typeId==="author") {
      return {
        id: 'author',
        icon: 'user-edit',
        label: '__AUTHORS_LABEL__'
      };
    } else if (typeId==="document") {
      return {
        id: 'document',
        icon: 'file-code',
        label: '__DOCUMENT_LABEL__'
      };
    } else if (typeId==="liveblog") {
      return {
        id: 'liveblog',
        icon: 'pencil',
        label: '__LIVEBLOG_LABEL__'
      };
    } else if (typeId==="liveblogevent") {
      return {
        id: 'liveblogevent',
        icon: 'file-code',
        label: '__LIVEBLOGEVENT_LABEL__'
      };
    } else if (typeId==="event") {
      return {
        id: 'event',
        icon: 'fa fa-calendar',
        label: '__EVENT_LABEL__'
      };
    } else {
      console.log("Please fix the new type (" + typeId + ") in this widget!");
      return {
        id: typeId,
        icon: typeId,
        label: typeId
      };
    }
  };

  var checkTrashPermission = function() {
    var deferred = $q.defer();
    var transferInfo = { id: configuration.getTrashExternalId() };
    ContentService.getContent(transferInfo).then(function(object) {
      configuration.setTrashId("contentid/" + object.id);
      deferred.resolve(configuration.getTrashId());
    }).then(null, function(error) {
      deferred.reject(error);
    });
    return deferred.promise;
  };

  var loadConfiguration = function() {
    if (_isLoading) {
      console.log("Load configuration is already in progress, skipping...");
      return loadDeferred.promise;
    }
    _isLoading = true;

    var modalInformer;

    return AuthenticationService.getCurrentUser().then(function(currentUser) {
      $rootScope.$broadcast("dam:loadConfigurationStart");
      if (!atex.dam.isTest) {
        modalInformer = DamInformerModal.create({ actionHeader: 'Starting dm.desk application...' });
        modalInformer.setActionMessage('Loading templates...');
      }
      return DamTemplateService.loadTemplates().then(function() {
        // There is no need to chain this step, it's just to show what the app is currently doing in the modalInformer [max]
        if (!atex.dam.isTest) {
          modalInformer.setActionMessage('Loading Fields Mapping!');
        }
        return DamFieldMappingService.loadMapping();
      }).then(function() {
        return DamService.getSolrServerInfo();
      }).then(function() {
        return DamPartitionsService.loadPartitions();
      }).then(function() {
        angular.forEach(terms, function(term, key) {
          DamService.getSearchConfiguration(term).then(function(response) {
            var solrTerm = DamFieldMappingService.getMapping(term.term);
            var tmp = response.data.terms[solrTerm];
            var result = [];
            if (tmp !== undefined) {
              for (var i = 0; i < tmp.length; i = i + 2) {
                // IMPORTANT: "collection-share" and "query-share" are still here to avoid issue in a migrated environment
                // in which no reload has been done on the solr "onecms" core
                if (solrTerm === "atex_desk_objectType" && (tmp[i] === "collection-share" || tmp[i] === "query-share" || tmp[i] === "folder" || tmp[i] === "query")) {
                  // Do not use as a real object type
                  continue;
                }
                result.push(tmp[i]);
              }
              lookups[terms[key].name] = result;
              // in case of 'types' let's transform from id array to obj array to be used into ui-select
              if (terms[key].name===type.name && lookups[terms[key].name]!==undefined) {
                for (i=0; i<lookups[terms[key].name].length; i++) {
                  lookups[terms[key].name][i] = createObjFromObjType(lookups[terms[key].name][i]);
                }
              }

              if (terms[key].name===partition.name && lookups[terms[key].name]!==undefined) {
                for (i=0; i<lookups[terms[key].name].length; i++) {
                  lookups[terms[key].name][i] = createObjFromPartition(lookups[terms[key].name][i]);
                }
              }

              if (terms[key].name===source.name && lookups[terms[key].name]!==undefined) {
                for (i=0; i<lookups[terms[key].name].length; i++) {
                  lookups[terms[key].name][i] = createObjFromSource(lookups[terms[key].name][i]);
                }
              }
            }
          });
        });
      }).then (function() {
        return DamService.getCurrentDamUserInfo();
      }).then (function() {
        return DamMarkAsService.loadColors();
      }).then (function() {
        return DamMarkAsService.loadIcons();
      }).then (function() {
        return DamMarkAsService.loadMultiIcons();
      }).then (function() {
        return DownloadService.loadTypes();
      }).then(function() {
        return DamMarkAsService.loadSmartUpdateRules();
      }).then(function() {
        return DamMarkAsService.loadSendContentRules();
      }).then(function() {
        return DamMarkAsService.loadExports();
      }).then(function() {
        return DamGalleryConfiguration.loadConfigurations();
      }).then(function() {
        return DamTemplateService.loadActTemplates();
      }).then(function() {
        var imageLocations = ["img/video.png", "img/embed.png", "img/image.png", "img/article.png", "img/multiple.png",
          "img/generic.png"];
        preloader.preloadImages(imageLocations);
      }).then (function() {
        return checkTrashPermission().then(null, function(error) {
          console.log("checkTrashPermission false");
        });
      }).then (function() {
        if (!$rootScope.atexIptcfieldsConfig) {
          return $.getJSON(imageMetadataConfigFile, function (json) {
            $rootScope.atexIptcfieldsConfig = angular.copy(json);
          });
        }
      }).then (function() {
        _isLoading = false;
        $rootScope.$broadcast("dam:loadConfigurationEnd");
        loadDeferred.resolve();
        if (!atex.dam.isTest) {
          return modalInformer.destroy();
        } else {
          return;
        }
      }).then(null, function(error) {
        var message = (error && error.cause) ? error.cause : "Generic error!";
        DamNotificationService.addNotification(atex.dam.Notification({ type: 'error', message: message }), true);

        console.log('ERROR: Performing configuration load:', error);
        _isLoading = false;
        $rootScope.$broadcast("dam:loadConfigurationEnd");
        loadDeferred.resolve();
        return modalInformer.destroy();
      });
    });
  };

  $rootScope.$on("onecms:authenticationSuccess", function() {
    checkTrashPermission();
  });

  return {
    loadConfiguration: function() {
      return loadConfiguration();
    },

    isLoadCfgInProgress: function() {
      return _isLoading;
    },

    getSearchLookups: function() {
      return lookups;
    },

    getCropFormats: function() {
      if (cropFormats.length>0) {
        return $q.when(cropFormats);
      }
      return ContentService.getContent({id: 'com.atex.onecms.image.ImageFormatConfigurationContent'}).then(function (responseInfo) {
        cropFormats = responseInfo.data.aspects.contentData.data.formats;
        return cropFormats;
      });
    },

    getCropFormatByName: function(cropFormatName) {
      return this.getCropFormats().then(function (formats) {
        return _.find(formats, function(format) {
          return format.name === cropFormatName;
        });
      });
    }
  };

}]);
